const keys = [
  "vorname",
  "nachname",
  "leseschwaeche",
  "afb1Points",
  "afb1Tb",
  "afb1Remarks",
  "afb2Points",
  "afb2Tb",
  "afb2Remarks",
  "afb3Points",
  "afb3Tb",
  "afb3Remarks",
  "sprachePoints",
  "spracheTb",
  "spracheRemarks",
  "spracheKorrektPoints",
  "spracheKorrektTb",
  "spracheKorrektRemarks",
  "spracheAusdruckPoints",
  "spracheAusdruckTb",
  "spracheAusdruckRemarks",
  "spracheLesenPoints",
  "spracheLesenTb",
  "spracheLesenRemarks",
  "zusammenfassung"
];

export const textbausteinTypes = {
  afb1Tb: "AFB I: Problemerfassung und Sacherschließung",
  afb2Tb: "AFB II: Problem- und Sachanalyse",
  afb3Tb: "AFB III: Urteil",
  spracheTb: "Sprachverwendung",
  spracheKorrektTb: "Sprachliche Korrektheit",
  spracheAusdruckTb: "Sprachlicher Ausdruck",
  pracheLesenTb: "Lesefreundliche Form"
};

export const textbausteinTypes1 = {
  afb1Tb: {headline: "AFB I: Problemerfassung und Sacherschließung", long: "Sach- bzw. Problemerschließung (überwiegend AFB I)"},
  afb2Tb: {headline: "AFB II: Problem- und Sachanalyse", long: "Sach- bzw. Problemanalyse (überwiegend AFB II)"},
  afb3Tb: {headline: "AFB III: Urteil", long: "Urteil (überwiegend AFB III)"},
  spracheTb: {headline: "Sprachverwendung", long: "Sprachverwendung"},
  spracheKorrektTb: {headline: "Sprachliche Korrektheit", long: "Sprachliche Korrektheit"},
  spracheAusdruckTb: {headline: "Sprachlicher Ausdruck", long: "Sprachlicher Ausdruck"},
  spracheLesenTb: {headline: "Lesefreundliche Form", long: "Lesefreundliche Form"}
};
